/** A next action in a game */

export interface GameAction<T extends string = string> {
  id: T
  name: string
  description: string
  /** Score multiplier for a correct answer */
  scoreMultiplier: number
  /** The minimum proficiency required to perform this game action */
  minProficiency: number
  /** The maximum proficiency required to perform this game action */
  maxProficiency: number
}

export const getAction = <T extends string = string>({
  gameActions,
  proficiency,
}: {
  gameActions: GameAction<T>[]
  proficiency: number
}) => {
  const actions = gameActions.filter(action => {
    const { minProficiency, maxProficiency } = action
    return proficiency >= minProficiency && proficiency <= maxProficiency
  })
  const action = actions[Math.floor(Math.random() * actions.length)]
  return action
}
